"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractor = exports.UserServiceContractorDetails = void 0;
var lodash_1 = require("lodash");
var helpers_1 = require("../../helpers");
var properties = ['user_service_contract_id', 'account_id', 'prolonged_at', 'canceled_at', 'status', 'created_at', 'updated_at', 'deleted_at'];
var dateProperties = ['prolonged_at', 'canceled_at', 'created_at', 'updated_at', 'deleted_at'];
/** Детали заказа на оплату контракта на услугу или продления контракта на услугу */
var UserServiceContractorDetails = /** @class */function () {
  function UserServiceContractorDetails(values) {
    if (!values) {
      return;
    }
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['billing_processor', 'billing_provider_id', 'billing_currency_id', 'billing_order_id', 'fixed_meeting_price']));
  }
  return UserServiceContractorDetails;
}();
exports.UserServiceContractorDetails = UserServiceContractorDetails;
/** Сторона контракта на оказание услуги, когда ученик записался на одно или несколько занятий к преподавателю */
var UserServiceContractor = /** @class */function () {
  function UserServiceContractor(values) {
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, properties));
    (0, helpers_1.assignDates)(this, values, dateProperties);
    this.details = new UserServiceContractorDetails(values === null || values === void 0 ? void 0 : values.details);
  }
  return UserServiceContractor;
}();
exports.UserServiceContractor = UserServiceContractor;
